export default __webpack_public_path__ + "static/media/AfterPhoto1.b24cd7bf.jpg";